import { render } from "./SecurityPanel.vue?vue&type=template&id=40bb0dd5&scoped=true"
import script from "./SecurityPanel.vue?vue&type=script&lang=js"
export * from "./SecurityPanel.vue?vue&type=script&lang=js"

import "./SecurityPanel.vue?vue&type=style&index=0&id=40bb0dd5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40bb0dd5"]])

export default __exports__